'use client'

import { FileText, LucideIcon } from 'lucide-react'
import { useLocale, useTranslations } from 'next-intl'

import { cn, getLocalizedExternalUrl } from '@/lib/utils'

import { Button } from '../ui/button'

interface GenericTutorialGuideButtonProps {
  textButton?: string
  tutorialLink?: string
  icon?: LucideIcon
  className?: string
}

export const GenericTutorialGuideButton = ({
  textButton,
  tutorialLink,
  icon: Icon,
  className,
}: GenericTutorialGuideButtonProps) => {
  const t = useTranslations('Common.Components')
  const locale = useLocale()

  if (!tutorialLink) return null

  const urlWithLocale = getLocalizedExternalUrl(tutorialLink, locale)

  const Label = textButton || t('generic_tutorial_guide_button')
  const TutorialIcon = Icon ?? FileText

  return (
    <Button variant="outline" type="button" className={cn('w-full sm:w-fit', className)}>
      <a href={urlWithLocale} target="_blank" rel="noopener noreferrer" className="flex items-center">
        <TutorialIcon className="mr-2 h-4 w-4" />
        {Label}
      </a>
    </Button>
  )
}

GenericTutorialGuideButton.displayName = 'GenericTutorialGuideButton'
